import * as React from 'react';
export const SvgAirplane = (props) => {
    return (React.createElement("svg", { viewBox: '0 0 16 16', width: '1rem', height: '1rem', fill: 'var(--iui-color-icon-muted, currentColor)', ...props },
        React.createElement("path", { d: 'M14.003 15.433L12.467 4.735l3.004-3.008s.801-1.204.4-1.605c-.333-.334-1.601.401-1.601.401L11.199 3.6.585 1.994l-.601.602L8.462 6.34l-4.139 4.145-3.07-.2-1.07 1.135 2.47.67c-.4 1.336-.2 1.47-.2 1.47s.2.2 1.469-.2l.667 2.473 1.135-1.07-.2-3.075 4.139-4.145 3.738 8.49z' })));
};
export default SvgAirplane;
